module.exports = __webpack_public_path__ + "static/media/filios-sazeides-lg3TETZvqv4-unsplash.8d64c151.webp";